import { TABLE } from "./db";
export var TOKEN = /* @__PURE__ */ ((TOKEN2) => {
  TOKEN2["CLIENT"] = "client";
  TOKEN2["ACCOUNT"] = "account";
  TOKEN2["SECRET"] = "secret";
  TOKEN2["CHECKOUT"] = "checkout";
  TOKEN2["SUBSCRIPTION"] = "subscription";
  TOKEN2["INSTRUMENT"] = "instrument";
  TOKEN2["ADDRESS"] = "address";
  TOKEN2["MESSAGE"] = "message";
  TOKEN2["EVENT"] = "event";
  TOKEN2["CUSTOM_FLOW"] = "custom_flow";
  TOKEN2["FLOW_TEMPLATE"] = "flow_template";
  TOKEN2["CORE_FLOW_INSTANCE"] = "core_flow_instance";
  TOKEN2["CUSTOM_FLOW_INSTANCE"] = "custom_flow_instance";
  TOKEN2["FLOW_INSTANCE_GROUP"] = "flow_instance_group";
  TOKEN2["SHORT_TOKEN"] = "short_token";
  TOKEN2["INBOUND_KEYWORD"] = "inbound_keyword";
  TOKEN2["MERCHANT_FAQ"] = "merchant_faq";
  TOKEN2["SEGMENT"] = "segment";
  TOKEN2["TRIGGER"] = "trigger";
  TOKEN2["POPUP"] = "popup";
  return TOKEN2;
})(TOKEN || {});
export const OLD_TOKEN_TO_NEW_TOKEN = {
  flow_instance: "custom_flow_instance" /* CUSTOM_FLOW_INSTANCE */,
  custom_flow_instance_group: "flow_instance_group" /* FLOW_INSTANCE_GROUP */
};
export const TOKEN_TYPE_TO_TABLE = {
  ["checkout" /* CHECKOUT */]: TABLE.CHECKOUT,
  ["subscription" /* SUBSCRIPTION */]: TABLE.SUBSCRIPTION,
  ["instrument" /* INSTRUMENT */]: TABLE.INSTRUMENT,
  ["address" /* ADDRESS */]: TABLE.ADDRESS,
  ["message" /* MESSAGE */]: TABLE.MESSAGE,
  ["account" /* ACCOUNT */]: TABLE.ACCOUNT,
  ["custom_flow" /* CUSTOM_FLOW */]: TABLE.CUSTOM_FLOW,
  ["flow_template" /* FLOW_TEMPLATE */]: TABLE.FLOW_TEMPLATE,
  ["flow_instance_group" /* FLOW_INSTANCE_GROUP */]: TABLE.FLOW_INSTANCE_GROUP,
  ["short_token" /* SHORT_TOKEN */]: TABLE.SHORT_TOKEN,
  ["inbound_keyword" /* INBOUND_KEYWORD */]: TABLE.INBOUND_KEYWORD,
  ["merchant_faq" /* MERCHANT_FAQ */]: TABLE.MERCHANT_FAQ,
  ["segment" /* SEGMENT */]: TABLE.SEGMENT,
  ["trigger" /* TRIGGER */]: TABLE.TRIGGER,
  ["popup" /* POPUP */]: TABLE.POPUP
};
export const TOKEN_TYPE_TO_ID = [
  "custom_flow_instance" /* CUSTOM_FLOW_INSTANCE */,
  "core_flow_instance" /* CORE_FLOW_INSTANCE */
];
